import React, { useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { addOnlineForm } from 'actions';

import LocalisedMessage from 'components/Common/LocalisedMessage';
import QuestionInformationBox from 'components/Questionnaires/QuestionInformationBox';

const RemainingW8Result = ({ id, title, info, accountId, formTypes, messageValues }) => {
  const dispatch = useDispatch();
  const availableFormTypes = useSelector(state => state.app?.onlineConfig?.formTypes);

  const isFormSupported = (type) => {
    const form = availableFormTypes.find(f => f.formType === type);
    return (form?.isEnabled === true && form?.isVisible === true);
  };

  const isSupported = (formType) => {
    if (!availableFormTypes) {
      return false;
    }
    if (formType) {
      return isFormSupported(formType);
    }

    return false;
  };

  const openNewForm = (formType) => {
    if (formType) {
      const formTypeInfo = availableFormTypes?.find(f => f.formType === formType.toLowerCase());
      dispatch(addOnlineForm(formTypeInfo, accountId));
    } else {
      console.log('error: missing formType');
    }
  };

  useEffect(() => {
    const lastCard = document.getElementById('formResult');
    if (window && lastCard && lastCard.offsetTop) {
      window.scrollTo({ top: lastCard.offsetTop - 100 });
    }
  }, []);

  return (<div id={ id } className="question-card-wrapper">
    <div className="questions">
      <div className="question">
        <span className="d-block">
          <legend className="question-title d-inline-block mt-2 mb-1"><LocalisedMessage id={ title } messageValues={ messageValues } /></legend>
        </span>
        <div className="buttoms-container">
          { formTypes && formTypes.length > 0 && formTypes.filter(f => isSupported(f.formType)).map(f => <button
            key={ f.title }
            className="btn questionnaire-button"
            type="button"
            onClick={ () => openNewForm(f.formType) }
          >
            { f.title }
          </button>) }
        </div>
        { info && <QuestionInformationBox messageValues={ messageValues } { ...info.componentProps } /> }
      </div>
    </div>
  </div>);
};

RemainingW8Result.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  info: PropTypes.shape(),
  accountId: PropTypes.number.isRequired,
  formTypes: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    formType: PropTypes.string
  })).isRequired,
  messageValues: PropTypes.shape()
};

RemainingW8Result.defaultProps = {
  info: null,
  messageValues: {}
};

export default RemainingW8Result;
